import { render } from "./App.vue?vue&type=template&id=79bde48d"
const script = {}
script.render = render

export default script